module.exports = __webpack_public_path__ + "static/media/our-courses-img-1.6bb44a3c.jpg";